<script lang="ts" setup>
    import { formatDateTime } from '@cwd/Shared/utils/formatDateTime';
    import { formatNumber } from '@cwd/Shared/utils/formatNumber';
    import { getSubscriptionStatusClass } from '@views/BackOffice/Subscription/Subscription.access';
    import { onMounted } from 'vue';
    import { ServiceSubscriptionListItem } from './SubscriptionList.access';

    const props = defineProps<{
        subscription: ServiceSubscriptionListItem;
        index: number;
    }>();

    const paymentMethodLabels: Record<number, string> = {
        1: 'Betalkortskund',
        2: 'PDF-faktura',
        3: 'Pappersfaktura',
        4: 'E-faktura',
    };

    onMounted(async () => {});
</script>

<template>
    <div class="flex-1" style="min-width: min(400px, 100%)" v-if="subscription">
        <h4 class="h4 item-heading">
            <i class="fa fa-square m-xxs-r" aria-hidden="true" :class="getSubscriptionStatusClass(subscription)"></i>
            <router-link :to="{ name: 'SubscriptionEdit', params: { serviceSubscriptionId: subscription.ServiceSubscriptionId } }">
                {{ subscription.ClientCompanyName }}
            </router-link>
            <span class="mini-label mini-label-default">{{ paymentMethodLabels[subscription.DefaultPaymentMethod] }}</span>
        </h4>

        <p>
            {{ subscription.Tier }} {{ formatNumber(subscription.TierContactLimit) }}
            <span v-if="subscription.monthlyPriceWithAddons != null">
                | {{ formatNumber(subscription.monthlyPriceWithAddons) }} {{ subscription.CurrencyCode }}
            </span>
        </p>

        <p class="meta">
            <i class="fa fa-leaf" aria-hidden="true"></i>
            {{ $Resources.CreatedLabel }}
            <time :datetime="subscription.Created">{{ formatDateTime(subscription.Created) }}</time>

            <template v-if="subscription.End != null">
                <i class="fa fa-calendar" aria-hidden="true"></i>
                Avslutas {{ formatDateTime(subscription.End) }}
            </template>

            <template v-if="subscription.ClientCompanyEmail != null">
                <i class="fa fa-user" aria-hidden="true"></i>
                {{ subscription.ClientCompanyEmail }}
            </template>
        </p>
    </div>
</template>
